module.exports = __webpack_public_path__ + "img/DW365-199.39afd4cc.jpg";